import { CommissionsRepository } from '@core/repositories/commissions.repository';
import { Commission } from '@shared/interfaces/commission';
import { Observable, of, throwError } from 'rxjs';

interface ResultCommissions {
  id: string;
  attributes: {
    startValue: number;
    endValue: number;
    fixValue: number;
    variableValue: number;
  };
  relationships: {
    channel: {
      id: string;
      name: string;
    };
  };
}

export class FakeCommissionsRepository implements CommissionsRepository {
  url: string;

  dataCommissions: Array<ResultCommissions> = [
    {
      id: '1',
      attributes: {
        startValue: 200000,
        endValue: 400000,
        fixValue: 4500,
        variableValue: 3
      },
      relationships: {
        channel: {
          id: '301',
          name: 'Canal1'
        }
      }
    },
    {
      id: '2',
      attributes: {
        startValue: 400001,
        endValue: 600000,
        fixValue: 4900,
        variableValue: 6
      },
      relationships: {
        channel: {
          id: '301',
          name: 'Canal1'
        }
      }
    },
    {
      id: '3',
      attributes: {
        startValue: 200000,
        endValue: 400000,
        fixValue: 4000,
        variableValue: 1.5
      },
      relationships: {
        channel: {
          id: '401',
          name: 'Canal2'
        }
      }
    }
  ];

  commissions = {
    data: this.dataCommissions
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.commissions);
  }

  add(commission: Commission): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(commission: Commission): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
